module.exports = __webpack_public_path__ + "img/onsalegoods.464e7cb7.png";